import React, { useState, useEffect } from "react";
import { API_BASE_URL } from "../config/config";
import { useNavigate } from "react-router-dom";
import "../Passports.css";

function BusinessFormation() {
  const navigate = useNavigate();

  // Data States
  const [countries, setCountries] = useState([]);
  const [documentData, setDocumentData] = useState({});
  const [documentOptions, setDocumentOptions] = useState([]);
  const deliveryMethods = ["WhatsApp", "Telegram", "Jabber", "E-mail"];

  // Selection States
  const [selectCountry, setSelectCountry] = useState('');
  const [selectOption, setSelectOption] = useState(''); 
  const [selectPrice, setSelectPrice] = useState(0);
  const [selectDeliveryMethod, setSelectDeliveryMethod] = useState('');



   useEffect(() => {
    // document ki jagah window.document use karein
    const inputs = window.document.querySelectorAll('input[required], select[required]');
    
    inputs.forEach(input => {
        input.oninvalid = (e) => {
            e.target.setCustomValidity("Complete this section.");
        };
        input.oninput = (e) => {
            e.target.setCustomValidity("");
        };
    });
}, [selectDeliveryMethod, documentOptions]);


  const getData = async () => {
    let slug = "business-formation";
    try {
      const response = await fetch(`${API_BASE_URL}/get-options?slug=${slug}`);
      const result = await response.json();
      if (result.success === 1) {
        setCountries(result.countries);
        setDocumentData(result.documents[0] || {});
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => { getData(); }, []);

  const handleForm = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formEntries = Object.fromEntries(formData.entries());

    const allOrderData = {
      ...formEntries,
      select_country: selectCountry,
      select_document_type: selectOption,
      price: selectPrice,
      delivery_method: selectDeliveryMethod,
      service_type: "Business Formation",
    };

    navigate(`/checkout?price=${selectPrice}&plan=${encodeURIComponent(selectOption)}`, {
      state: { orderData: allOrderData },
    });
  };

  // Variables Definition
  const optionLower = selectOption.toLowerCase();
  const isAlreadyRegistered = optionLower.includes("already");
  // Agar "already" nahi hai, toh baaki cases ke liye isRegisterForm true hoga
  const isRegisterForm = optionLower !== "" && !isAlreadyRegistered;

  return (
    <div className="passport-container">
      <div className="product-main">
        <div className="product-image-box">
          <div className="placeholder-img">
            <img src={documentData.image_path || "../pass.jpg"} alt="Service" />
          </div>
        </div>

        <div className="product-info">
          <h2 className="prod-title">{documentData.title || "Business Formation Documents"}</h2>

          {/* 1. SELECT COUNTRY */}
          <div className="field-group">
            <label>Select Documents Country</label>
            <select required value={countries.find(c => c.name === selectCountry)?.id || ""} onChange={(e) => {
              const selected = countries.find(c => c.id == e.target.value);
              if (selected) {
                setSelectCountry(selected.name);
                setDocumentOptions(selected.document_options);
                setSelectOption(""); 
                setSelectPrice(0);
              }
            }}>
              <option value="">Choose...</option>
              {countries.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>

          {/* 2. SELECT DOCUMENT TYPE */}
          {documentOptions.length > 0 && (
            <div className="field-group">
              <label>Select Document Type</label>
              <select required value={documentOptions.find(o => o.title === selectOption)?.id || ""} onChange={(e) => {
                const opt = documentOptions.find(o => o.id == e.target.value);
                if (opt) {
                  setSelectOption(opt.title);
                  setSelectPrice(opt.price);
                }
              }}>
                <option value="">Choose...</option>
                {documentOptions.map((opt) => (
                  <option key={opt.id} value={opt.id}>{opt.title} (${opt.price})</option>
                ))}
              </select>
            </div>
          )}

          {/* PRICE DISPLAY */}
          {selectPrice > 0 && (
            <div className="total-price-box" style={{ margin: '15px 0', padding: '12px', backgroundColor: '#f8f9fa', borderLeft: '4px solid #000' }}>
              <strong>Total Price: ${selectPrice}</strong>
            </div>
          )}

          {/* 3. DELIVERY METHOD */}
          {selectPrice > 0 && (
            <div className="field-group">
              <label>Select Delivery Method</label>
              <select required onChange={(e) => setSelectDeliveryMethod(e.target.value)}>
                <option value="">Choose...</option>
                {deliveryMethods.map(m => <option key={m} value={m}>{m}</option>)}
              </select>
            </div>
          )}

          {/* 4. DYNAMIC ORDER DETAILS */}
          {selectDeliveryMethod && (
            <form className="order-details-box modern-card" onSubmit={handleForm}>
              <h3>Order Details</h3>
              <div className="input-grid">

                {/* --- SCENARIO 1: ALREADY REGISTERED (Serf 3 Fields) --- */}
                {isAlreadyRegistered && (
                  <>
                    <input
                      name="delivery_handle"
                      required
                      placeholder={`Enter your ${selectDeliveryMethod} for delivery`}
                    />
                    <input
                      name="city_state"
                      placeholder="Specify City/State (Optional)"
                    />
                    <textarea
                      name="instructions"
                      placeholder="Extra Instructions (Optional)"
                      className="full-width"
                    />
                  </>
                )}

                {/* --- SCENARIO 2: REGISTER YOUR BUSINESS / OTHERS (9 Fields) --- */}
                {isRegisterForm && (
                  <>
                    <input
                      name="delivery_handle"
                      required
                      placeholder={`Enter your ${selectDeliveryMethod} for delivery`}
                      className="full-width"
                    />
                    <input name="business_name" required placeholder="Business Name" />
                    <input name="owner_name" required placeholder="Business Owner Name" />
                    <input name="business_address" placeholder="Business Address (Optional)" />
                    <input name="owner_address" placeholder="Business Owner Address (Optional)" />
                    <input name="ssn_nic" required placeholder="Business Owner SSN/NIC" />
                    <input
                      name="business_type"
                      placeholder="Business Type (LLC/CORP/Non-Profit)"
                    />
                    <input name="city_state" placeholder="Business City/State (Optional)" />
                    <textarea
                      name="instructions"
                      placeholder="Extra Instructions (Optional)"
                      className="full-width"
                    />
                  </>
                )}

              </div>
              <button type="submit" className="buy-btn">PROCEED TO CHECKOUT</button>
            </form>
          )}
        </div>
      </div>

      <div className="product-description">
        <h4 className="mt-4">Product Details</h4>
        <div dangerouslySetInnerHTML={{ __html: documentData.content || '' }} />
      </div>
    </div>
  );
}

export default BusinessFormation;